module.exports = __webpack_public_path__ + "img/icon_ylfw .d0c5e7e5.png";